import Renderer from "@wielink/datatables/Renderers/Renderer";

class ActionRenderer extends Renderer {
	render() {
		let editUrl = this.config.editUrl;
		let showUrl = this.config.showUrl;

		for(let key in this.row) {
			let regex = new RegExp(`\/_${key}_?`)
			editUrl = editUrl.replace(regex, '/' + this.row[key]);
			showUrl = showUrl.replace(regex, '/' + this.row[key]);
		}

		return `
			<div class="d-inline-flex gap-2">
				<a href="${showUrl}" data-dt-btn="show" class="btn btn-sm btn-secondary" aria-label="Bewerken" title="Bewerken">
					<i class="bi bi-search"></i>
				</a>
				<a href="${editUrl}" data-dt-btn="edit" class="btn btn-sm btn-success" aria-label="Bewerken" title="Bewerken">
					<i class="bi bi-pencil-square"></i>
				</a>
				<button data-dt-btn="delete" data-id="${this.row.id}" class="btn btn-sm btn-danger" aria-label="Verwijderen" title="Verwijderen">
					<i class="bi bi-trash3-fill"></i>
				</button>
			</div>
		`
	}
}

export default ActionRenderer;